module.exports = __webpack_public_path__ + "img/cp-bg.0b8d1bea.jpg";